import React from "react";
import ReactDOM from "react-dom";
import "../src/assets/styles/base.scss";
import App from "./App";
import { Router } from "react-router-dom";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { createBrowserHistory } from "history";
import { RefreshPlanItemCountProvider } from "./context/refreshPlanItemCount";
import { OnboardingStepCountProvider } from "./context/onboardingStepCount";
import { ReactQueryProvider } from "./context/ReactQueryProvider";
import { UserProvider } from "./context/UserContext";

const history = createBrowserHistory();

ReactDOM.render(
  <ReactQueryProvider>
    <Router history={history}>
      <UserProvider>
        <OnboardingStepCountProvider>
          <RefreshPlanItemCountProvider>
            <App />
          </RefreshPlanItemCountProvider>
        </OnboardingStepCountProvider>
      </UserProvider>
    </Router>
  </ReactQueryProvider>,
  document.getElementById("root")
);
